import { HTTPRequest, UITourContainer } from '@bimser/common';
import { BCNotification, findMessage } from '@bimser/components';
import { base64Converter, safeRedirect } from '@bimser/core';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainApp from './MainApp';
import Style from './assets/style.scss';
import IRouterCProps from './entities/IRouterCProps';
import IRouterProps from './entities/IRouterProps';

const LoginMainContainer = React.lazy(
	() => import('@bimser/common/dist/components/Login/containers/LoginMainContainer')
);

const Router = (props: IRouterProps & IRouterCProps) => {
	const [fromMobile, setFromMobile] = React.useState(false);

	React.useEffect(() => {
		if (location.hash.includes('mobile')) {
			setFromMobile(true);
		} else if (location.hash.includes('delegate') || location.hash.includes('loginAs')) {
			try {
				const type = location.hash.includes('delegate') ? 'delegate' : 'loginAs';
				const payload = location.hash.split(`${type}/`)[1];
				if (payload) {
					const querystringJson = base64Converter.Base64ToString(payload);
					const querystring = JSON.parse(querystringJson);
					if (querystring?.token && querystring.encryptedData) {
						sessionStorage.setItem('token', querystring.token);
						HTTPRequest.setHeaders({
							'bimser-encrypted-data': querystring.encryptedData
						});
						if (querystring.user) {
							const user = querystring.user;
							const title = location.hash.includes('loginAs')
								? findMessage.get('102389')
								: findMessage.get('102464');
							BCNotification.success({
								message: title,
								description: findMessage.get('102465').replace('{0}', user)
							});
						}

						if (location.hash.includes('loginAs') && querystring.redirectUrl) {
							setTimeout(() => safeRedirect(querystring.redirectUrl), 500);
						} else if (!location.hash.includes('loginAs')) {
							props.setDelegateInformation(true);
						}
					}
				}
			} catch (error) {
				console.error('Error:', error);
			}
			location.hash = '';
		} else if (location.hash.includes('/auth')) {
			const hashWithoutParameters = location.hash.split('?')[0];
			const splittedHash = hashWithoutParameters.split('/');
			const authIndex = splittedHash.findIndex(i => i === 'auth');
			if (authIndex > -1) {
				const id = splittedHash[authIndex + 1];
				const language = splittedHash[authIndex + 2];
				const useAuthCode = splittedHash[authIndex + 3] === 'UseAuthCode';
				if (id && language && typeof id === 'string' && typeof language === 'string') {
					switch (id) {
						case 'AUTH_SERV_0033': {
							BCNotification.warning({ message: findMessage.get('102431') });

							location.hash = useAuthCode ? '#/OAuth/Failed' : '#/';
							break;
						}
						case 'AUTH_SERV_0043': {
							BCNotification.warning({ message: findMessage.get('102437') });

							location.hash = useAuthCode ? '#/OAuth/Failed' : '#/';
							break;
						}
						case 'AUTH_SERV_0041': {
							BCNotification.warning({ message: findMessage.get('102438') });

							location.hash = useAuthCode ? '#/OAuth/Failed' : '#/';
							break;
						}
						default: {
							props.onOAuthLogin({
								id,
								language,
								useAuthCode
							});
						}
					}
				} else {
					BCNotification.warning({ message: findMessage.get('102431') });
					location.hash = useAuthCode ? '#/OAuth/Failed' : '#/';
				}
			}
		} else {
			props.onSSOControl?.();
		}

		props.getLoginParameters({
			DomainAddress: location.origin,
			synergyLogonApp: location.hash.includes('/_redirect') ? 'SharedLink' : 'WebInterface'
		});
	}, []);

	const getRoute = () => {
		if (!props.checkAuthenticationFinished) {
			return null;
		}

		if (fromMobile || props.isAuthenticated) {
			return (
				<Route
					path="/*"
					element={<MainApp />}
				/>
			);
		}

		if (location.hash.includes('/OAuthResult/')) {
			if (!location.hash.split('OAuthResult/')[1]) {
				location.hash = '#/';
			} else {
				return (
					<Route
						path="/*"
						element={
							<div className={Style.OAuthResultMessage}>
								<span>{findMessage.get('102382')}</span>
								<span>{findMessage.get('102383')}</span>
							</div>
						}
					/>
				);
			}
		}

		return (
			<Route
				path="/*"
				element={<LoginApp />}
			/>
		);
	};

	return (
		<>
			<UITourContainer />
			<Routes>{getRoute()}</Routes>
		</>
	);
};

export default Router;

const LoginApp = () => (
	<React.Suspense fallback={<></>}>
		<LoginMainContainer />
	</React.Suspense>
);
